export default __webpack_public_path__ + "static/media/640_dummy2016-heimtier01-de-mobile.cedb15e5.png";